import React from 'react'
import { FORM_LINE_UP_BUQUES } from '../../../../config/forms'
import DialogView from '../../../Dialogos/DialogView'
import { EMPLY_LINE_UP_BUQUES } from '../../actions/constantesBuquesAnunciados'
import AnunciarBuqueDialogView from './AnunciarBuqueDialogView'
import { reduxForm, formValueSelector } from 'redux-form'
import { connect } from 'react-redux'

const AnunciarBuqueDialog = (props) => {
  const { confirmCallback, cancelCallback } = props

  const handleSubmit = () => {
    confirmCallback()
  }

  return (
    <DialogView
      confirmCallback={handleSubmit}
      cancelCallback={cancelCallback}
      title='Anunciar buque'
      content={
        <AnunciarBuqueDialogView />
      }
    />
  )
}

const selector = formValueSelector(FORM_LINE_UP_BUQUES)
const mapStateToProps = (state) => ({
  cereal: selector(state, 'cereal'),
  toneladas: selector(state, 'toneladas'),
  exportador: selector(state, 'exportador'),
  paisDestino: selector(state, 'paisDestino'),
  paises: state.pais.paises
})

export default reduxForm({
  form: FORM_LINE_UP_BUQUES,
  initialValues: EMPLY_LINE_UP_BUQUES,
  enableReinitialize: true
})(connect(mapStateToProps, null)(AnunciarBuqueDialog))
